module.exports = __webpack_public_path__ + "img/brand_aigostar.bdc9d1cf.png";